export const resolveEndpoint = (
	endpoint,
	bankId,
	scopeId,
	accountId,
	customerId,
	{
		beneficiaryId = null,
		page = '',
		size = '',
		search = '',
		paymentType = '',
		accountNumber = '',
		sortCode = '',
		benType = '',
		name = '',
	} = {}
) => {
	let newEndpoint = endpoint;
	if (bankId) {
		newEndpoint = newEndpoint.replace(':bankId', bankId);
	}
	if (scopeId) {
		newEndpoint = newEndpoint.replace(':scopeId', scopeId);
	}
	if (accountId) {
		newEndpoint = newEndpoint.replace(':accountId', accountId);
	}
	if (customerId) {
		newEndpoint = newEndpoint.replace(':customerId', customerId);
	}
	newEndpoint = newEndpoint.replace(':beneficiaryId', beneficiaryId);
	newEndpoint = newEndpoint.replace(':page', page);
	newEndpoint = newEndpoint.replace(':size', size);
	newEndpoint = newEndpoint.replace(':search', search);
	newEndpoint = newEndpoint.replace(':paymentType', paymentType);
	newEndpoint = newEndpoint.replace(':accountNumber', accountNumber);
	newEndpoint = newEndpoint.replace(':sortCode', sortCode);
	newEndpoint = newEndpoint.replace(':benType', benType);
	newEndpoint = newEndpoint.replace(':name', name);

	return newEndpoint;
};

const endpoints = {
	paymentHistory: {
		uri: 'paas-base-url:/ibapi/v2/banks/:bankId/accounts/:scopeId/paymenthistory/searches',
		x_bpi_version: '1.3.0',
		method: 'POST',
		resolve(bankId, scopeId) {
			return resolveEndpoint(this.uri, bankId, scopeId);
		},
	},

	userPaymentHistory: {
		uri: 'paas-base-url:/ibapi/v2/banks/:bankId/accounts/:scopeId/paymenthistory/searches/user',
		x_bpi_version: '1.3.0',
		method: 'POST',
		resolve(bankId, scopeId) {
			return resolveEndpoint(this.uri, bankId, scopeId);
		},
	},

	approvals: {
		uri: 'paas-base-url:/ibapi/v2/banks/:bankId/accounts/:scopeId/approvals/searches',
		x_bpi_version: '1.3.0',
		method: 'POST',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, bankId, scopeId, accountId);
		},
	},

	userApprovals: {
		uri: 'paas-base-url:/ibapi/v2/banks/:bankId/accounts/:scopeId/approvals/searches/user',
		x_bpi_version: '1.3.0',
		method: 'POST',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, bankId, scopeId, accountId);
		},
	},
	cancelApproval: {
		uri: '/banks/:bankId/accounts/:scopeId/:accountId/approvals/:approvalId',
		x_bpi_version: '1.3.0',
		method: 'DELETE',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, bankId, scopeId, accountId);
		},
	},

	allVerifications: {
		uri: 'paas-base-url:/ibapi/v2/banks/:bankId/user/verification/all',
		x_bpi_version: '1.2.0',
		method: 'GET',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, bankId, scopeId, accountId);
		},
	},

	deleteVerification: {
		uri: 'paas-base-url:/ibapi/v2/banks/:bankId/user/:scopeId/verification/:verificationId',
		x_bpi_version: '1.2.0',
		method: 'DELETE',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, bankId, scopeId, accountId);
		},
	},
	cancelBatchApproval: {
		uri: 'paas-base-url:/ibapi/v2/banks/:bankId/user/:scopeId/verification/:verificationId',
		x_bpi_version: '1.3.0',
		method: 'DELETE',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, bankId, scopeId, accountId);
		},
	},
	updateVerification: {
		uri: 'paas-base-url:/ibapi/v2/banks/:bankId/user/:scopeId/verification/:verificationId',
		x_bpi_version: '1.2.0',
		method: 'PUT',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, bankId, scopeId, accountId);
		},
	},
	getAllBeneficiaries: {
		uri: 'paas-base-url:/ibapi/v2/banks/:bankId/accounts/:scopeId/beneficiaries',
		x_bpi_version: '0.8.0',
		method: 'GET',
		resolve(bankId, scopeId) {
			return resolveEndpoint(this.uri, bankId, scopeId);
		},
	},
	getExchangeRate: {
		uri: 'paas-base-url:/ibapi/v2/banks/:bankId/accounts/:scopeId/:accountId/fx',
		x_bpi_version: '1.0.0',
		method: 'POST',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, bankId, scopeId, accountId);
		},
	},
	getCustomerCapabilities: {
		uri: 'paas-base-url:/ibapi/v2/banks/:bankId/customers/:customerId/capabilities',
		x_bpi_version: '0.8.0',
		method: 'GET',
		resolve(bankId, customerId) {
			return resolveEndpoint(this.uri, bankId, undefined, undefined, customerId);
		},
	},
	getLcvAccounts: {
		uri: 'paas-base-url:/ibapi/v2/banks/:bankId/accounts/default?page=:page&size=:size&search=:search&paymentType=:paymentType&searchAccountNumber=:accountNumber&searchSortCode=:sortCode',
		x_bpi_version: '0.8.0',
		method: 'GET',
		resolve({ page = 1, size = 60, search, paymentType, accountNumber, sortCode }) {
			return resolveEndpoint(this.uri, undefined, undefined, undefined, undefined, {
				page,
				size,
				search,
				paymentType,
				accountNumber,
				sortCode,
			});
		},
	},
	getLcvPayees: {
		uri: 'paas-base-url:/ibapi/v2/banks/:bankId/accounts/default/beneficiaries?page=:page&benType=:benType&size=:size&search=:search&searchAccountNumber=:accountNumber&searchSortCode=:sortCode&searchPayeeName=:name',
		x_bpi_version: '0.8.0',
		method: 'GET',
		resolve({ page, size, search, benType, accountNumber, sortCode, name }) {
			return resolveEndpoint(this.uri, undefined, undefined, undefined, undefined, {
				page,
				size,
				search,
				benType,
				accountNumber,
				sortCode,
				name,
			});
		},
	},
	getBeneficiaryById: {
		uri: 'paas-base-url:/ibapi/v2/banks/:bankId/accounts/default/beneficiaries/:beneficiaryId',
		x_bpi_version: '0.8.0',
		method: 'GET',
		resolve(beneficiaryId) {
			return resolveEndpoint(this.uri, undefined, undefined, undefined, undefined, { beneficiaryId });
		},
	},
	multipart: {
		uri: 'paas-base-url:/ibapi/v2/banks/:bankId/user/:scopeId/batch',
		x_bpi_version: '1.2.0',
		method: 'POST',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, bankId, scopeId, accountId);
		},
	},
	getAccountDetails: {
		uri: '/ibapi/v2/banks/:bankId/accounts/default/:accountId',
		x_bpi_version: '0.8.0',
		method: 'GET',
		resolve(accountId) {
			return resolveEndpoint(this.uri, undefined, undefined, accountId);
		},
	},
};

export default endpoints;
